export var LEARNING_OBJECTIVES_OPTIONS = [{
  label: '2',
  value: 2
}, {
  label: '3',
  value: 3
}, {
  label: '4',
  value: 4
}, {
  label: '5',
  value: 5
}, {
  label: '6',
  value: 6
}];
export var TONE_OPTIONS = [{
  label: 'Exam oriented',
  value: 'exam_oriented'
}, {
  label: 'Casual',
  value: 'casual'
}, {
  label: 'Funny',
  value: 'funny'
}, {
  label: 'Serious',
  value: 'serious'
}];